var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.025c.6 0 1-.4 1-1v-9c0-.3-.1-.6-.4-.8l-6-5c-.4-.3-.9-.3-1.3 0l-6 5c-.2.2-.3.5-.3.8v9c0 .6.4 1 1 1h4v-5h4v5h4z",
    fill: "#F36C23"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZD0iTTEzIDE2LjAyNWMuNiAwIDEtLjQgMS0xdi05YzAtLjMtLjEtLjYtLjQtLjhsLTYtNWMtLjQtLjMtLjktLjMtMS4zIDBsLTYgNWMtLjIuMi0uMy41LS4zLjh2OWMwIC42LjQgMSAxIDFoNHYtNWg0djVoNHoiIGZpbGw9IiNGMzZDMjMiIGZpbGwtcnVsZT0ibm9uemVybyIvPgo8L3N2Zz4K";
export { SvgHome as ReactComponent };